import { createBoardObject } from './create'
import { deleteBoardObject } from './delete'
import { readBoardObjects } from './read'
import { resourceObject } from './resourceObject'
import { updateBoardObject } from './update'

export const boardObjects = {
  create: createBoardObject,
  readCollection: readBoardObjects,
  clientResource: resourceObject,
  delete: deleteBoardObject,
  update: updateBoardObject,
}

export * from './cacheTransformFns'

export * from './queryHelpers'
